function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocShoppingCartRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 26a2 2 0 10.001 4.001A2 2 0 0012 26zM26 26a2 2 0 10.001 4.001A2 2 0 0026 26zM11.733 21.148L9.244 4.554A2.982 2.982 0 006.277 2H3v2h3.277c.499 0 .915.357.989.851l2.489 16.594A2.983 2.983 0 0012.722 24H28v-2H12.722a.994.994 0 01-.989-.852z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.34 5l2.1 14h10.836a4.001 4.001 0 003.99-3.715L29 5H11.34z",
    fill: props.color
  }));
}

export default SvgIconPocShoppingCartRexFilled;